import type { IClient } from "@/models/clients";
import type { IFile } from "@/models/common";

/**
 * Root stip type containing properties shared across all stip types.
 */
export type BaseStip = {
  id: number;
  name: string;
  description: string | null;
  file_type: string;
};

/**
 * A stip as it's defined in settings.
 * (Previously `IStip`)
 */
export type StipDefinition = BaseStip & {
  weight: number;
  is_dynamic: boolean;
  dynamic_type: string | null;
  client: Pick<IClient, "id" | "name"> | null;
};

/**
 * A stip assigned to an application.
 * (Previously `IRequiredStipForOffer`)
 */
export type ApplicationStip = BaseStip & {
  stip_id: StipDefinition["id"];
  count: number;
  files: IFile[];
  is_finished: boolean;
};

/**
 * A stip assigned to an offer of an application.
 * (Previously `IRequiredStipForOffer`)
 */
export type OfferStip = ApplicationStip;

/**
 * A stip assigned to an application, or the offer of an application.
 * (Previously `IRequiredStipForOffer`)
 */
export type DealStip = ApplicationStip | OfferStip;

/**
 * A stip as it's being created or edited within the stips modal
 */
export type FieldStip = BaseStip & {
  count: DealStip["count"];
};

export const isStipDefinition = (
  stip: StipDefinition | DealStip
): stip is StipDefinition => {
  return !("stip_id" in stip);
};

export const isDealStip = (
  stip: StipDefinition | DealStip | FieldStip
): stip is DealStip => {
  return "stip_id" in stip;
};
